<template>
  <header class="call-top-bar">
    <div class="top-bar-left">
      <div class="logo-container">
        <img
          src="@/assets/images/logo-lila.png"
          alt="Lila"
          class="logo"
        >
        <span class="call-title">Consulta Online</span>
      </div>
    </div>

    <div class="top-bar-right">
      <span
        class="status-indicator"
        :class="{ connected: connected }"
      />
      <span class="call-duration">{{ formattedDuration }}</span>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  connected?: boolean;
  startedAt?: number;
  currentTime?: number;
  professionalName?: string;
}

const props = withDefaults(defineProps<Props>(), {
  connected: false,
  startedAt: 0,
  currentTime: 0,
  professionalName: ""
});

const formattedDuration = computed(() => {
  if (!props.startedAt || !props.currentTime) return "00:00";

  const elapsed = Math.floor((props.currentTime - props.startedAt) / 1000);
  const minutes = Math.floor(elapsed / 60);
  const seconds = elapsed % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
});
</script>

<style scoped>
.call-top-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: transparent;
  z-index: 10;
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-container {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 20px;
  width: auto;
}

.call-title {
  color: #4f3f82;
  font-size: 14px;
  font-weight: 600;
}

.professional-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.top-bar-right {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e0e0e0;
  padding: 8px 14px;
  border-radius: 20px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #6b7280;
}

.status-indicator.connected {
  background-color: #22c55e;
}

.call-duration {
  color: #4f3f82;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
</style>
